import { week1StartUnixMs } from "../season";
export const WEEK_LENGTH_MS = 604800000;
export const LEAGUE_TIME_ZONE = "America/Chicago";
const localParts = timestamp => Object.fromEntries(new Intl.DateTimeFormat("en-US", {
  timeZone: LEAGUE_TIME_ZONE, year: "numeric", month: "numeric", day: "numeric",
  hour: "numeric", minute: "numeric", second: "numeric", hourCycle: "h23",
}).formatToParts(new Date(timestamp)).filter(p => p.type !== "literal").map(p => [p.type, Number(p.value)]));

export function weekStartUnixMs(week, baseWeek1Start = week1StartUnixMs) {
  return baseWeek1Start + (Math.max(1, week) - 1) * WEEK_LENGTH_MS;
}

// Thursday 19:30 Chicago wall time, including the November DST transition.
export function lockUnixMs(week, baseWeek1Start = week1StartUnixMs) {
  const p = localParts(weekStartUnixMs(week, baseWeek1Start));
  const date = new Date(Date.UTC(p.year, p.month - 1, p.day));
  date.setUTCDate(date.getUTCDate() + (4 - date.getUTCDay() + 7) % 7);
  const wall = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 19, 30);
  let candidate = wall;
  for (let i = 0; i < 2; i++) {
    const z = localParts(candidate);
    const offset = Date.UTC(z.year, z.month - 1, z.day, z.hour, z.minute, z.second) - candidate;
    candidate = wall - offset;
  }
  return candidate;
}

export function isPassedDue(nowUnixMs, week, baseWeek1Start = week1StartUnixMs) {
  return nowUnixMs >= lockUnixMs(week, baseWeek1Start);
}

